<template>
  <el-dialog
    ref="selectCoupon"
    :title="title"
    :visible.sync="visible"
    width="70%"
    :append-to-body="true"
  >
    <el-form ref="query" :model="query" size="mini" :inline="true">
      <el-form-item label="隶属公司">
        <el-input v-model="query.merchantName" placeholder="请输入公司名称" clearable />
      </el-form-item>
      <el-form-item label="优惠券名称" v-show="query.type === 2">
        <el-input v-model="query.name" placeholder="请输入优惠名称" clearable />
      </el-form-item>
      <el-form-item label="礼包名称" v-show="query.type === 1">
        <el-input v-model="query.giftName" placeholder="请输入礼包名称" clearable />
      </el-form-item>
      <el-form-item>
        <avue-radio
          v-model="query.type"
          :dic="[
            { label: '优惠券', value: 2 },
            { label: '礼包', value: 1 }
          ]"
          :disabled="disable"
          @change="search"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table
      v-loading="queryLoading"
      :data="data"
      ref="multipleTable"
      border
      size="mini"
      max-height="280"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true" />
      <el-table-column
        v-if="query.type === 1"
        label="礼包名称"
        prop="name"
        width="150"
        key="giftName"
      />
      <el-table-column v-else label="优惠名称" prop="name" width="150" key="name" />
      <el-table-column
        v-if="query.type === 2"
        label="金额/个"
        prop="discountsMoney"
        key="discountsMoney"
      />
      <el-table-column
        v-if="query.type === 2"
        label="有效期"
        prop="endIndate"
        width="150"
        key="endIndate"
      />
      <el-table-column v-if="query.type === 2" label="可用线路" prop="lineName" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.isAll === 0">
            <div class="range-text">{{
              Array.isArray(scope.row.lineName) ? scope.row.lineName.join(';') : ''
            }}</div>
            <el-button
              v-if="Array.isArray(scope.row.lineName) && scope.row.lineName.length > 4"
              type="text"
              size="mini"
              @click="moreRange(scope.row.lineName)"
              >查看更多</el-button
            >
          </div>
          <div v-else>全部线路</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="query.type === 2"
        label="剩余数量"
        prop="surplusNum"
        key="surplusNum"
      />
      <el-table-column label="归属批次" prop="batchName" width="150" />
      <el-table-column v-if="query.type === 2" label="归属礼包" prop="giftName" width="150" />
      <el-table-column label="归属供应商" prop="merchantName" width="150" />
      <el-table-column
        v-if="query.type === 1"
        label="金额/个"
        prop="discountsMoney"
        key="discountsMoney2"
      />
      <el-table-column
        v-if="query.type === 1"
        label="剩余数量"
        prop="surplusNum"
        key="surplusNum2"
      />
      <el-table-column label="创建人" prop="createUserName" width="100" key="createUserName" />
      <el-table-column
        v-if="query.type === 1"
        label="创建时间"
        prop="createTime"
        width="180"
        key="createTime"
      />
    </el-table>
    <pagination
      v-if="page.total > 0"
      :total="page.total"
      :page.sync="page.current"
      :limit.sync="page.size"
      @pagination="refresh"
    />
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="danger" @click="reset">取 消</el-button>
      <el-button type="primary" size="small" @click="submit">确 定</el-button>
    </div>
    <el-dialog
      title="可用线路"
      :visible.sync="moreVisible"
      :append-to-body="true"
      width="50%"
      :before-close="closeMoreRange"
    >
      <div class="range-box">
        <div v-for="(item, index) in this.range" :key="index">
          <span style="padding-left: 15px">{{ item }}</span>
        </div>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import { selectCouponpPage } from '@/api/marketing/activities-api'
  export default {
    name: 'selectCoupon',
    props: {
      title: {
        type: String,
        default: '添加优惠券'
      },
      disable: {
        // 优惠券礼包是否可以切换
        type: Boolean,
        default: false
      },
      selectType: {
        // 优惠券礼包类型,默认优惠券
        type: Number,
        default: 2
      }
    },
    data() {
      return {
        visible: false,
        query: {
          type: 2
        },
        page: {
          current: 1,
          size: 10,
          total: 0
        },
        items: [],
        data: [],
        selections: [],
        range: [],
        queryLoading: false
      }
    },
    methods: {
      init() {
        this.visible = true
        this.$nextTick(() => {
          this.$set(this.query, 'name', '')
          this.$set(this.query, 'giftName', '')
          this.data = []
          this.page.current = 1
          this.query.type = this.selectType
          this.onLoad(this.page, this.query)
        })
      },
      search() {
        this.data = []
        this.page.current = 1
        this.onLoad(this.page)
      },
      getRowKeys(row) {
        return row.id
      },
      refresh() {
        this.data = []
        this.onLoad(this.page)
      },
      async onLoad(page, params) {
        const adonData = {
          current: this.page.current,
          size: this.page.size,
          ...this.query
        }
        this.queryLoading = true
        await selectCouponpPage(Object.assign(adonData, params))
          .then((resp) => {
            this.items = resp.data.records
            if (this.items) {
              this.items.forEach((item) => {
                const copyonData = {
                  batchId: item.batchId,
                  batchName: item.batchName,
                  createTime: item.createTime,
                  createUserName: item.createUserName,
                  discountsMoney: item.discountsMoney,
                  giftName: item.giftName,
                  merchantName: item.merchantName,
                  id: item.id,
                  name: item.name,
                  surplusNum: item.surplusNum,
                  totalNum: item.totalNum,
                  type: item.type,
                  isAll: item.isAll,
                  lineName: item.lineName,
                  endIndate:
                    item.dateType === 1 ? item.endIndate : `领取后${item.expipyDate}天有效`,
                  num: 1,
                  couponType: item.couponType
                }
                this.data.push(copyonData)
              })
            }
            this.page.total = resp.data.total
          })
          .finally(() => {
            this.queryLoading = false
          })
      },
      reset() {
        this.visible = false
        this.data = []
        this.query = {
          type: 1
        }
      },
      handleSelectionChange(val) {
        this.selections = val
      },
      submit() {
        this.$emit('getCouponItem', this.selections)
        this.$store.commit('ADD_SELECT_COUPON', this.selections)
        this.$refs.multipleTable.clearSelection()
        this.reset()
      },
      moreRange(range) {
        this.range = range
        this.moreVisible = true
      },
      closeMoreRange() {
        this.range = []
        this.moreVisible = false
      }
    }
  }
</script>

<style scoped>
  .range-box {
    height: 350px;
    width: 95%;
    overflow: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    flex-wrap: wrap;
  }
  .range-text {
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
